import { render, staticRenderFns } from "./ReceptionLobby.vue?vue&type=template&id=a4b280f2&scoped=true"
import script from "./ReceptionLobby.vue?vue&type=script&lang=js"
export * from "./ReceptionLobby.vue?vue&type=script&lang=js"
import style0 from "./ReceptionLobby.vue?vue&type=style&index=0&id=a4b280f2&prod&lang=scss&scoped=true"
import style1 from "./ReceptionLobby.vue?vue&type=style&index=1&id=a4b280f2&prod&lang=scss"
import style2 from "./ReceptionLobby.vue?vue&type=style&index=2&id=a4b280f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b280f2",
  null
  
)

export default component.exports